import mixpanel from "mixpanel-browser";

import { analyticsProjectToken } from "../../config";

mixpanel.init(analyticsProjectToken);

export const analytics = mixpanel;
